<div>
    <div class="dialog_content">

        <div class="form_row" style="align-items: center">

            <!-- VIRTUAL BLOCK FOR ALIGNMENT ACTIONS: ONE DEPOT AND DIRECTION -->
            <div class="form_row_item" *ngIf="dialog_has_mag_ref">
                <p-dropdown styleClass="form_select_mid" appendTo="body" [options]='optionsMagRef' [(ngModel)]="edits_magRef" placeholder="magazzino" [disabled]="optionsMagRef.length == 1" (onChange)="onChangeDepotRef()"></p-dropdown>
            </div>
            <div class="form_row_item" style="display: flex; align-items: center"  *ngIf="dialog_has_mag_ref">
                <p-radioButton name="direction_incoming" [value]="true" [(ngModel)]="edits_direction_incoming" inputId="mov_direction"  (onClick)="onChangeDirection()" />
                <label for="direction_incoming" class="ml-2">in entrata</label>
            </div>
            <div class="form_row_item" style="display: flex; align-items: center"  *ngIf="dialog_has_mag_ref">
                <p-radioButton name="direction_outgoing" [value]="false" [(ngModel)]="edits_direction_incoming" inputId="mov_direction"  (onClick)="onChangeDirection()" />
                <label for="direction_outgoing" class="ml-2">in uscita</label>
            </div>
            <!-- END VIRTUAL BLOCK FOR ALIGNMENT ACTIONS: ONE DEPOT AND DIRECTION -->

            <!-- VIRTUAL BLOCK FOR MAG TO MAG -->
            <div class="form_row_item" *ngIf="dialog_has_mag_from">
                <p-dropdown styleClass="form_select_mid" appendTo="body" [options]='optionsMagFrom' [(ngModel)]="edits_magFrom" placeholder="origine"  (onChange)="onChangeDepotFrom()" [group]="true" [disabled]="lockedMagFrom">
                    <ng-template let-group pTemplate="group">
                        <div class="flex align-items-center">
                            <span>{{ group.label }}</span>
                        </div>
                     </ng-template>
                </p-dropdown>
            </div>
            <div class="form_row_item" *ngIf="dialog_has_mag_to">
                <p-dropdown styleClass="form_select_mid" appendTo="body" [options]='optionsMagTo' [(ngModel)]="edits_magTo" placeholder="destinazione"  (onChange)="verifyForm()" [group]="true">
                    <ng-template let-group pTemplate="group">
                        <div class="flex align-items-center">
                            <span>{{ group.label }}</span>
                        </div>
                     </ng-template>

                </p-dropdown>
            </div>

            <!-- END VIRTUAL BLOCK FOR MAG TO MAG -->

            <!-- VIRTUAL BLOCK FOR INSTALLATION ACTIONS: SCHOOL/ACTION  -->
            <div class="form_row_item" *ngIf="dialog_has_pratica">
                <p-dropdown styleClass="form_select_mid" [filter]="true" optionLabel="label" filterBy="cui" filterMatchMode="contains" optionValue="value" appendTo="body" [options]='optionsScuole' [(ngModel)]="edits_praticaScuola" placeholder="scuola/pratica" [disabled]="optionsScuole.length == 1" (onChange)="verifyForm()"></p-dropdown>
            </div>
            <!-- END VIRTUAL BLOCK FOR ALIGNMENT ACTIONS: ONE DEPOT AND DIRECTION -->



            <div style="flex-grow: 1"></div>

            <div class="form_row_item">
                <div class="p-inputgroup">
                    <p-calendar styleClass="calendargroup" [ariaLabel]="'Data'" [maxDate]="max_date" appendTo="body" [showOnFocus]="false" [showIcon]="true" [(ngModel)]="edits_movdate"  (change)="verifyForm()"></p-calendar>
                </div>
            </div>

            <div style="flex-grow: 1"></div>

            <div class="form_row_item">
                <div class="p-inputgroup">

                <p-dropdown styleClass="form_select_mid ddgroupright" appendTo="body" [options]='optionsMateriali' [(ngModel)]="currentOptionMateriali" placeholder="modello dispositivo"></p-dropdown>
                <button pButton type="button" icon="pi pi-plus" pTooltip="Aggiungi materiali alla movimentazione" tooltipPosition="top"
                    class="font-['Poppins']"
                    style="background-color:#ffffff; color: cadetblue; border-color: cadetblue; font-size: 13px;" label="Aggiungi"
                    [disabled]=" currentOptionMateriali == null"
                    (click)="addToMaterialsList()"
                ></button>
                </div>
            </div>

            <div class="form_row_item">
                <p-overlayPanel #op appendTo="body">
                    <textarea rows="5" cols="30" pTextarea [(ngModel)]="edits_notes"></textarea>
                </p-overlayPanel>
                <p-button (click)="op.toggle($event)" icon="pi pi-file-edit" pTooltip="Note"></p-button>


            </div>

        </div>


        <div style="max-height: 50vh; overflow-y: auto" [ngSwitch]="edits_materiali.length > 0">

            <h3>Lista Materiali</h3>

            <div class="warning" *ngSwitchCase="false">nessun materiale impostato per la movimentazione</div>

            <p-table styleClass="p-datatable-sm" [value]="edits_materiali" dataKey="id"
              responsiveLayout="stack" *ngSwitchCase="true">

                    <ng-template pTemplate="header">
                        <tr>
                            <th pSortableColumn="id">
                                <div class="flex justify-content-between align-items-center">
                                    NMU
                                </div>
                            </th>
                            <th>
                                <div class="flex justify-content-between align-items-center">
                                    descrizione
                                </div>
                            </th>
                            <th>
                                <div class="flex justify-content-between align-items-center">
                                    quantità
                                </div>
                            </th>
                            <th *ngIf="dialog_has_mag_from || (dialog_has_mag_ref && !edits_direction_incoming)">
                                <div class="flex justify-content-between align-items-center">
                                    disponibili
                                </div>
                            </th>
                            <th *ngIf="dialog_has_mag_from || (dialog_has_mag_ref && !edits_direction_incoming)">
                                <div class="flex justify-content-between align-items-center">
                                    avanzo
                                </div>
                            </th>
                            <th>
                                <div class="flex justify-content-between align-items-center">

                                </div>
                            </th>
                        </tr>
                    </ng-template>

                    <ng-template pTemplate="body" let-row>
                        <tr>

                            <td><span class="text-lowercase">{{ row.modello.nmu }}</span></td>
                            <td style="width: 100%"><span class="text-lowercase">{{ row.modello.descrizione }}</span></td>
                            <td><span class="text-lowercase">

                                <p-inputNumber [(ngModel)]="row.qt" [showButtons]="true" buttonLayout="horizontal" inputId="horizontal" [step]="1" [min]="0" incrementButtonIcon="pi pi-plus" decrementButtonIcon="pi pi-minus" [size]="5" (onInput)="verifyForm()">
                                </p-inputNumber>

                            </span></td>
                            <td *ngIf="dialog_has_mag_from  || (dialog_has_mag_ref && !edits_direction_incoming)">
                                <span *ngIf="dialog_has_mag_ref && edits_magRef != null">
                                    {{materialsByDepot[this.edits_magRef.codice][this.row.modello.id]}}
                                </span>
                                <span *ngIf="dialog_has_mag_from && edits_magFrom != null">
                                    {{materialsByDepot[this.edits_magFrom.codice][this.row.modello.id]}}
                                </span>
                            </td>
                            <td *ngIf="dialog_has_mag_from  || (dialog_has_mag_ref && !edits_direction_incoming)">
                                <span *ngIf="dialog_has_mag_ref && edits_magRef != null">
                                    {{materialsByDepot[this.edits_magRef.codice][this.row.modello.id] - row.qt}}
                                </span>
                                <span *ngIf="dialog_has_mag_from && edits_magFrom != null">
                                    {{materialsByDepot[this.edits_magFrom.codice][this.row.modello.id] - row.qt}}
                                </span>
                            </td>
                            <td><span class="text-lowercase">
                                <button pButton type="button" icon="pi pi-trash" pTooltip="Rimuovi" tooltipPosition="top"
                                    class="font-['Poppins']"
                                    label="Elimina"
                                    (click)="removeFromMaterialsList(row.modello.id)"
                                ></button>
                            </span></td>
                        </tr>
                    </ng-template>
                </p-table>

            </div>


    </div>

    <p-divider type="solid"></p-divider>

    <div class="dialog_controls">

            <p-button icon="pi pi-times" label="Annulla" class="p-button-text mr-1 row_button" (click)="onActivityCompleted(false)"></p-button>
            <p-button icon="pi pi-check" label="Conferma" class="p-button-text ml-100 row_button" styleClass="p-button-success" (click)="onActivityCompleted(true)" [disabled]="!hasValidForm"></p-button>
    </div>
</div>